// Component for redirecting. It's mainly used for falling back gracefully when we don't have a component for the route we're trying
// to render

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

class Redirect extends PureComponent {

  componentDidMount() {
    this.props.redirectFun();
  }

  render() {
    return (
      <h2>Unable to determine form section, redirecting to section one</h2>
    );
  }
}

Redirect.propTypes = {
  redirectFun: PropTypes.func,
};



export { Redirect };
